export enum TeamTab {
  All = 'all',
  Approved = 'approved',
  Pending = 'pending',
  Declined = 'declined',
}
